import { FaArrowRightToBracket, FaRegCircleUser } from "react-icons/fa6"
import Logo from "../Logo"
import { Link } from "react-router-dom"


const ProfileAuthMenu = ({ userData, onHandleLogout, isActivePath, role, user}) => {
  return (
  
              <div className="perfil align-center">
                <p className="capitalize text-right">
                  <span className="verde bold">
                    {userData?.name || user?.name}{" "}
                    {userData?.lastName || user?.lastName}
                  </span>
                  <br />
                  {userData?.role || role}
                </p>
                <Link
                  to="/admin/perfil"
                  aria-label="Mi perfil"
                  className={`${isActivePath("/admin/perfil") ? "activo" : "negro"} ml-[16px]`}
                >
                  <FaRegCircleUser className="text-[26px] mt-[11px]" />
                </Link>
                <button
                  onClick={onHandleLogout }
                  aria-label="Cerrar sesión"
                  className="negro logout-btn"
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  <FaArrowRightToBracket />
                </button>
              </div>
  )
}

export default ProfileAuthMenu